var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc16YearsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5432 8.46452C8.50251 12.9833 4.81865 23.8114 9.22081 32.6189C13.623 41.4263 24.4948 44.9792 33.5355 40.4604C41.0295 36.7148 44.85 28.6218 43.4198 20.9486C43.2324 19.9432 43.8956 18.9762 44.901 18.7888C45.9064 18.6014 46.8734 19.2646 47.0608 20.27C48.7929 29.5632 44.1673 39.287 35.1914 43.7734C24.3775 49.1784 11.2525 44.9678 5.90788 34.2747C0.563233 23.5817 5.07342 10.5567 15.8874 5.15159C24.9056 0.644059 35.517 2.82229 41.9009 9.86468C42.5878 10.6224 42.5304 11.7935 41.7726 12.4804C41.0149 13.1673 39.8438 13.1099 39.1569 12.3522C33.8864 6.53803 25.0728 4.70109 17.5432 8.46452Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9038 33.2737H13.7765V19.1916H11.0483V16.7756C12.9371 16.8446 14.1263 16.0853 14.8259 14.2905H17.9038V33.2737ZM26.0185 22.5051C26.788 21.8148 27.4176 21.2625 28.7467 21.2625C31.1951 21.2625 32.5242 23.3334 32.5242 27.13C32.5242 30.7196 31.5449 33.6188 27.1378 33.6188C24.0598 33.6188 22.5208 32.1002 21.9612 29.1319C21.7513 27.8894 21.6814 26.3017 21.6814 24.1618C21.7513 21.6077 21.7513 20.02 21.9612 18.7775C22.5208 15.8092 24.1297 14.2905 27.2077 14.2905C30.0059 14.2905 32.2444 16.0163 32.2444 18.8465V19.8129H28.327V19.3987C28.327 18.0872 27.8373 17.742 27.2077 17.742C26.3683 17.811 26.0185 18.5704 26.0185 19.6058V22.5051ZM27.2077 24.9901C26.3683 24.9901 26.0185 25.8185 26.0185 27.5442C26.0185 29.27 26.3683 30.0983 27.2077 30.0983C28.1171 30.0983 28.4669 29.27 28.4669 27.5442C28.4669 25.8185 28.1171 24.9901 27.2077 24.9901Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 24C34 23.3627 34.5084 22.8462 35.1355 22.8462H36.8952V21.1613C36.8952 20.5199 37.4069 20 38.0381 20C38.6693 20 39.181 20.5199 39.181 21.1613V22.8462H40.8645C41.4916 22.8462 42 23.3627 42 24C42 24.6373 41.4916 25.1538 40.8645 25.1538H39.181V26.8387C39.181 27.4801 38.6693 28 38.0381 28C37.4069 28 36.8952 27.4801 36.8952 26.8387V25.1538H35.1355C34.5084 25.1538 34 24.6373 34 24Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc16YearsActive);
export default __webpack_public_path__ + "static/media/ic_16years_active.429ebed31ce1dad5f4a3d4cf2125ac18.svg";
export { ForwardRef as ReactComponent };